import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import formatPrice from '@dc/ui-library/src/helpers/formatPrice';
import { resolveByCountry } from '@dc/ui-library/src/helpers/environment';
import CompareCheckbox from './components/CompareCheckbox.jsx';
import uiLocale from '../../../utils/UILocale.js';

const tooltipTranslation = uiLocale.getString('component.comparecheckbox.please_remove_product');

function getProductFromDigitalData(productId) {
  const products = window.digitalData.products || [];
  let foundProduct = products.find(
    product => product.productID === productId
  );
  if (foundProduct) {
    foundProduct = convertProductToAjaxAPIProductFormat(foundProduct);
  }
  return foundProduct;
}

function convertProductToAjaxAPIProductFormat(product) {
  const convertedProduct = {
    price: {},
    channelsAvailability: {
      defaultAvailability: {}
    }
  };

  // required props
  convertedProduct.id = product.productID;
  convertedProduct.link = product.productUrl;
  convertedProduct.image = {
    src: product.imageUrl
  };
  convertedProduct.title = product.productName;
  convertedProduct.price.price =
    formatPrice(product.currentPrice, false, resolveByCountry('GBP', 'EUR'));
  convertedProduct.isOutOfStock = !product.inStock;
  convertedProduct.isComboKit = product.isBundle;
  convertedProduct.channelsAvailability.defaultAvailability.showEmailMeBack =
    product.emailMeBack;
  convertedProduct.brand = {
    title: product.manufacturer
  };

  // optional props
  if (product.subItemNames.length > 0) {
    convertedProduct.comboKitItemNames = product.subItemNames.slice(1);
  }
  if (product.mainProductCurrentPrice) {
    convertedProduct.price.mainProductCurrentPrice =
      formatPrice(product.mainProductCurrentPrice, false, resolveByCountry('GBP', 'EUR'));
  }
  if (product.mainProductWasPrice) {
    convertedProduct.price.mainProductWasPrice =
      formatPrice(product.mainProductWasPrice, false, resolveByCountry('GBP', 'EUR'));
  }
  if (product.savingsPrice) {
    convertedProduct.price.savingsPrice =
      formatPrice(product.savingsPrice, false, resolveByCountry('GBP', 'EUR'));
  }
  if (product.separateSellingPrice) {
    convertedProduct.price.separateSellingPrice =
      formatPrice(product.separateSellingPrice, false, resolveByCountry('GBP', 'EUR'));
  }
  if (product.wasPrice) {
    convertedProduct.price.wasPrice =
      formatPrice(product.wasPrice, false, resolveByCountry('GBP', 'EUR'));
  }
  if (product.wasPriceFrom) {
    convertedProduct.price.wasPriceFrom = product.wasPriceFrom;
  }
  if (product.wasPriceTo) {
    convertedProduct.price.wasPriceTo = product.wasPriceTo;
  }

  return convertedProduct;
}

function initCompareCheckboxes() {
  let checkboxPlaceholders = document.querySelectorAll('[data-component="compare-checkbox"]');
  checkboxPlaceholders = Array.from(checkboxPlaceholders);

  const compareForm = document.querySelector('form[data-component="compareForm"]');
  let tooltipArrowDirection;

  // Tooltip arrow direction is different on list view and grid view.
  if (document.querySelector('div.resultList')) {
    tooltipArrowDirection = 'bottom';
  } else {
    tooltipArrowDirection = 'top';
  }

  checkboxPlaceholders.forEach((mountEl) => {
    const productId = mountEl.getAttribute('data-productid');
    if (!productId) {
      return;
    }
    const product = getProductFromDigitalData(productId);
    if (product) {
      ReactDOM.render(
        <Provider store={window.appState}>
          <CompareCheckbox
            tooltipArrowDirection={tooltipArrowDirection}
            containerFormEl={compareForm}
            product={product}
            tooltipTextTranslate={tooltipTranslation}
          />
        </Provider>,
        mountEl
      );
    }
  });
}

export default initCompareCheckboxes;
